import { useNavigationStore } from '@hb/react'
import { FORM_ERROR } from 'final-form'
import { useEffect, useRef } from 'react'
import { FormSpy, useForm } from 'react-final-form'

const NavigationGuardInner = ({
  dirty,
  formName,
}: {
  dirty: boolean | undefined
  formName: string
}) => {
  const setUnsavedFormChange = useNavigationStore(s => s.setUnsavedFormChange)
  const form = useForm()
  const submitRef = useRef(form.submit)
  submitRef.current = form.submit

  useEffect(() => {
    setUnsavedFormChange(
      dirty
        ? {
            formName,
            onSave: async () => {
              const errors = await submitRef.current()
              if (errors) throw new Error(errors[FORM_ERROR] || 'Form submission failed')
            },
          }
        : null,
    )
    return () => {
      setUnsavedFormChange(null)
    }
  }, [dirty, formName, setUnsavedFormChange])

  return null
}

export const NavigationGuard = ({ formName }: { formName: string }) => (
  <FormSpy subscription={{ dirty: true }}>
    {({ dirty }) => <NavigationGuardInner dirty={dirty} formName={formName} />}
  </FormSpy>
)
